import { render, staticRenderFns } from "./ForfunServerList.vue?vue&type=template&id=75aa6b32&scoped=true&"
import script from "./ForfunServerList.vue?vue&type=script&lang=js&"
export * from "./ForfunServerList.vue?vue&type=script&lang=js&"
import style0 from "./ForfunServerList.vue?vue&type=style&index=0&id=75aa6b32&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aa6b32",
  null
  
)

component.options.__file = "ForfunServerList.vue"
export default component.exports